var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$store.state.layout_style, _vm.$store.state.menu_style]},[_c(_vm.layout,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }